import { defineStore } from 'pinia';
import store from '@/store';
import { product_class } from '@/api/apis';
export var useProductStore = defineStore('useProductStore', () => {
  var type_list = ref([]);
  var current_name = ref(''); // 当前正在展示的二级产品
  var bread_item = ref(''); // 当前选中的面包屑
  var bread_list = ref([]);
  var scoll_top = ref(0);
  function get_product_class(obj) {
    return new Promise((resolve, reject) => {
      if (type_list.value && type_list.value.length != 0) {
        resolve(type_list.value);
      } else {
        product_class(obj).then(res => {
          if (res.code == 200) {
            type_list.value = res.data.data;
            resolve(res.data.data);
          }
        });
      }
    });
  }
  return {
    type_list,
    get_product_class,
    current_name,
    bread_item,
    scoll_top,
    bread_list
  };
});

// 非setup
export function useProductStoreHook() {
  return useProductStore(store);
}